import styled from 'styled-components';
import React, {useEffect} from 'react';
import {themecolors} from "../../utils/themecolors";
import ErrorBoundary from "../error_boundary";

export const WhizzcoInfeedUnit = styled(({className}) => {

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://cdn.whizzco.com/scripts/widget/widget_v3.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className={`${className} ad google-ad googleAd google-sponsored-links ads4 fullSizeAd`}>
            <ErrorBoundary>
                <div style={{ backgroundColor: '#fff', width: '300px', height: '300px', margin: '0 auto', overflow: 'hidden' }}>
                    <div className="ads_container" style={{height: '300px'}} website_id="2876" widget_id="7033" />
                </div>
            </ErrorBoundary>
        </div>
    )})`
    padding: 16px 12px;
  ${({theme, expand}) =>
    `
    & {
        border-${expand === 'card' ? 'top' : 'bottom'}: 1px solid ${theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
    }
    `
}
`;

export default WhizzcoInfeedUnit;